import React, { Component, ErrorInfo } from 'react';
import { ErrorState } from './ErrorState';

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | undefined;
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      error: undefined,
      hasError: false
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      error,
      hasError: true
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught by error boundary:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({
      error: undefined,
      hasError: false
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorState
          title="Something went wrong"
          message="We're sorry, but something went wrong. Please try again or contact support if the problem persists."
          error={this.state.error}
          onRetry={this.handleRetry}
          fullScreen
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;